module.exports = __webpack_public_path__ + "static/img/thanks-text.43a28ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/thanks-text.png
// module id = R5V4
// module chunks = 1